import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'superTrim'
})
/**
 * Trim left, right and multiple inner spaces.
 * @example "  I   am a         sentence  ." => "I am a sentence."
 */
export class SuperTrimPipe implements PipeTransform {
  transform(value: string): string {
    return value.trim().replace(/[\s]+/g, ' ');
  }
}
